import React from 'react';

const companies = [
  { name: 'Swiggy', logo: '/images/companyLogos/swiggy.webp' },
  { name: 'Accenture', logo: '/images/companyLogos/accenture.webp' },
  { name: 'Card91', logo: '/images/companyLogos/card91.webp' },
  { name: 'LoginRadius', logo: '/images/companyLogos/loginradius.webp' },
  { name: 'Mindtree', logo: '/images/companyLogos/mindtree.webp' },
  { name: 'Onix', logo: '/images/companyLogos/onix.webp' },
  { name: 'Kla', logo: '/images/companyLogos/kla.webp' },
  { name: 'Turing', logo: '/images/companyLogos/turing.webp' },
  { name: 'Infosys', logo: '/images/companyLogos/infosys.webp' },
  {
    name: 'AU Small Finance Bank',
    logo: '/images/companyLogos/au_small_finance_bank.webp',
  },
  { name: 'Bolt.Earth', logo: '/images/companyLogos/bolt_earth.webp' },
  { name: 'Envestnet', logo: '/images/companyLogos/envestnet.webp' },
  { name: 'Zypp', logo: '/images/companyLogos/zypp.webp' },
  { name: 'ZeTechno', logo: '/images/companyLogos/zetechno.webp' },
  { name: 'Workhall', logo: '/images/companyLogos/workhall.webp' },
  { name: 'Wego', logo: '/images/companyLogos/wego.webp' },
  { name: 'Webomates', logo: '/images/companyLogos/webomates.webp' },
  { name: 'Vishvin', logo: '/images/companyLogos/vishvin.webp' },
  { name: 'Veva', logo: '/images/companyLogos/veva.webp' },
  { name: 'VectorStack', logo: '/images/companyLogos/vectorstack.webp' },
  { name: 'Vaken', logo: '/images/companyLogos/vaken.webp' },
  { name: 'Urban Piper', logo: '/images/companyLogos/urbanpiper.webp' },
  {
    name: 'UNO Digital Bank',
    logo: '/images/companyLogos/unodigitalbank.webp',
  },
  { name: 'Troop', logo: '/images/companyLogos/troop.webp' },
  { name: 'Traveloka', logo: '/images/companyLogos/traveloka.webp' },
  { name: 'TestGrid', logo: '/images/companyLogos/testgrid.webp' },
  { name: 'TCS', logo: '/images/companyLogos/tcs.webp' },
  { name: 'Tacnique', logo: '/images/companyLogos/tacnique.webp' },
  { name: 'Sureify', logo: '/images/companyLogos/sureify.webp' },
  { name: 'Strique', logo: '/images/companyLogos/strique.webp' },
  { name: '10Decoders', logo: '/images/companyLogos/10decoders.webp' },
  { name: 'Academian', logo: '/images/companyLogos/academian.webp' },
  { name: 'ADP', logo: '/images/companyLogos/adp.webp' },
  {
    name: 'Airowire Networks',
    logo: '/images/companyLogos/airowire_networks.webp',
  },
  { name: 'Appscrip', logo: '/images/companyLogos/appscrip.webp' },
  { name: 'Arix', logo: '/images/companyLogos/arix.webp' },
  { name: 'Axis Bank', logo: '/images/companyLogos/axisbank.webp' },
  { name: 'Azentio', logo: '/images/companyLogos/azentio.webp' },
  { name: 'Brewcode', logo: '/images/companyLogos/brewcode.webp' },
  { name: 'CallHealth', logo: '/images/companyLogos/callhealth.webp' },
  { name: 'Claw', logo: '/images/companyLogos/claw.webp' },
  { name: 'Clinisys', logo: '/images/companyLogos/clinisys.webp' },
  { name: 'Credence ID', logo: '/images/companyLogos/credenceid.webp' },
  { name: 'Deloitte', logo: '/images/companyLogos/deloitte.webp' },
  { name: 'Jumbotail', logo: '/images/companyLogos/jumbotail.webp' },
  { name: 'WalkingTree', logo: '/images/companyLogos/walkingtree.webp' },
  { name: 'Mastercard', logo: '/images/companyLogos/mastercard.webp' },
  { name: 'PhonePe', logo: '/images/companyLogos/phonepe.webp' },
  { name: 'Oracle', logo: '/images/companyLogos/oracle.webp' },
  { name: 'Reliance', logo: '/images/companyLogos/reliance.webp' },
  { name: 'Spinny', logo: '/images/companyLogos/spinny.webp' },
];

const CompaniesSection = () => {
  return (
    <section className="flex flex-col items-center overflow-hidden bg-white py-10">
      <h2 className="mb-8 text-center font-manrope font-extrabold md:text-[44px] md:leading-[66px]">
        Work at Tech Unicorns,
        <br className="hidden md:block" /> High Growth Startups, MNCs and GCC
      </h2>

      <div className="relative w-full overflow-hidden">
        <div className="animate-scroll flex gap-10">
          {/* Duplicate logos to create infinite scroll effect */}
          {companies.concat(companies).map((company, index) => (
            <div key={index} className="flex items-center justify-center">
              <img
                src={company.logo}
                alt={company.name}
                className="w-[80px] object-contain md:w-[120px]"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Tailwind custom CSS inside <style> */}
      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .animate-scroll {
          animation: scroll 20s linear infinite;
        }
      `}</style>
    </section>
  );
};

export default CompaniesSection;
